import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@services/auth/token.service';
import { InventoryService } from '@services/inventory/inventory.service';
import { SharedService } from '@services/shared/shared.service';
import { TitleService } from '@services/title.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'environments/environment';
import { searchElement } from '../inventory-main/table.definition';
import { commonDtOptions, theads } from './table.definition';

@Component({
  selector: 'app-new',
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.scss'],
})
export class NewComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public dtOptions: any = {};
  public dtOptions2: any = {};
  public theads = theads;
  public tableData: object[] = [];
  public filteredData: object[] = [];
  public isFilterMode: boolean = false;
  public noFilterMode: boolean = true;
  public selectedKey: string = '';
  public activeFilterKeyValue: boolean;
  public filterOptions = {};
  public eventListener: () => void;
  public activeTab: 'available' | 'sold' = 'available';
  public makes: object = {};
  public models: object = {};
  public trimType: object = {};
  public modelYears: object = {};
  public exteriorColor: object = {};
  public showFilterPanel: boolean = false;

  constructor(
    private sharedService: SharedService,
    private inventoryService: InventoryService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private tokenService: TokenService,
    private renderer: Renderer2,
    private titleService: TitleService
  ) {
    this.dtOptions = this.getDtOptions();
    this.dtOptions2 = this.getDtOptions2();
  }

  ngOnInit(): void {
    this.titleService.updateTitle('New Inventory');

    this.activeTab = this.activatedRoute.snapshot.queryParamMap.get('type') as
      | 'available'
      | 'sold';
  }

  get activeFilterCount(): number {
    return Object.values(this.filterOptions).filter((v) => !!v).length;
  }

  ngAfterViewInit(): void {
    this.eventListener = this.renderer.listen('document', 'click', (event) => {
      if (event.target && event.target.closest('.view-btn')) {
        const productId = event.target
          .closest('.view-btn')
          .getAttribute('data-product-id');

        if (productId) {
          this.router.navigate([
            `/dashboard/inventory/vehicle-details/${productId}`,
          ]);
        }
      }
    });
  }

  ngAfterViewChecked() {
    // This is for to fix the style for show entries
    const parentElement = document.getElementById('new-vehicles_length');

    if (parentElement) {
      const labelElement = parentElement.querySelector('label');

      if (labelElement) {
        Object.assign(labelElement.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        });

        const selectElement = labelElement.querySelector('select');

        if (selectElement) {
          selectElement.style.width = '5rem';
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.eventListener();
  }

  tabSwitch(tabName: 'available' | 'sold') {
    this.activeTab = tabName;
    this.noFilterMode = true;
    this.isFilterMode = false;

    this.router.navigate([], {
      queryParams: { type: this.activeTab },
      queryParamsHandling: 'merge',
    });

    if (this.activeTab === 'sold') {
      this.dtOptions = this.getSoldDtOptions();
      return;
    }

    this.dtOptions = this.getDtOptions();
    this.dtOptions2 = this.getDtOptions2();
  }

  getDtOptions() {
    return {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          type: 3,
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        const additionalParams =
          this.activeTab === 'available' ? { buy: 0 } : { sold: true };

        const buildParam = { ...baseParams, ...additionalParams };

        this.http
          .get(environment.v5 + 'vam/product/list', {
            headers: this.tokenService.getTokenHeader(),
            params: buildParam,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareRetailAndNewTableData(
              resp['data'],
              'inventory-new'
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });

            if (resp['success']) {
              const baseParam = { type: 3 };
              const additionalParams =
                this.activeTab === 'available' ? { buy: 0 } : { sold: true };

              return this.http
                .post(
                  `${environment.v5}inventory/product/filters`,
                  { ...this.filterOptions, search_element: searchElement },
                  { params: { ...baseParam, ...additionalParams } }
                )
                .subscribe((res) => {
                  this.makes = res?.['data']?.[0]?.['Make'];
                  this.models = res?.['data']?.[1]?.['Model'];
                  this.modelYears = res?.['data']?.[2]?.['Model Year'];
                  this.trimType = res?.['data']?.[4]?.['Trim/Type'];
                  this.exteriorColor = res?.['data']?.[5]?.['Exterior Colour'];
                });
            }
          });
      },
    };
  }

  getDtOptions2() {
    return {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          type: 3,
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        let additionalParams =
          this.activeTab === 'available' ? { buy: 0 } : { sold: true };

        let activeParam =
          this.activeTab === 'available' && this.selectedKey === 'active'
            ? { active: this.activeFilterKeyValue }
            : {};

        const buildParam = {
          ...baseParams,
          ...additionalParams,
          ...activeParam,
        };

        this.http
          .post(
            environment.api + 'inventory/product/search',
            { ...this.filterOptions },
            {
              headers: this.tokenService.getTokenHeader(),
              params: buildParam,
            }
          )
          .subscribe((resp) => {
            this.filteredData = this.sharedService.prepareRetailAndNewTableData(
              resp['data'],
              'new'
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.filteredData,
            });

            if (resp['success']) {
              this.http
                .post(
                  `${environment.v5}inventory/particular/product/filter`,
                  { ...this.filterOptions, search_element: searchElement },
                  {
                    headers: this.tokenService.getTokenHeader(),
                    params: buildParam,
                  }
                )
                .subscribe((res) => {
                  this.makes = res?.['data']?.[0]?.['Make'];
                  this.models = res?.['data']?.[1]?.['Model'];
                  this.modelYears = res?.['data']?.[2]?.['Model Year'];
                  this.trimType = res?.['data']?.[4]?.['Trim/Type'];
                  this.exteriorColor = res?.['data']?.[5]?.['Exterior Colour'];
                });
            }
          });
      },
    };
  }

  getSoldDtOptions() {
    return {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          type: 3,
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        const buildParam = { ...baseParams };

        this.http
          .get(environment.v5 + 'sold/car/list', {
            headers: this.tokenService.getTokenHeader(),
            params: buildParam,
          })
          .subscribe((resp) => {
            this.tableData = this.sharedService.prepareRetailAndNewTableData(
              resp['data'],
              'inventory-new'
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  searchProductsFromList(event: Event) {
    let debounseTime: number = 500;
    let timerId: NodeJS.Timeout;

    if (timerId) {
      clearTimeout(timerId);
    }

    this.isFilterMode = false;
    this.noFilterMode = false;
    this.selectedKey = (event.target as HTMLInputElement).name;
    const value = (event.target as HTMLInputElement).value;

    if (this.selectedKey === 'active') {
      this.activeFilterKeyValue = JSON.parse(value);
      this.filterOptions = { ...this.filterOptions, 'Body Type': '' };
    } else {
      this.filterOptions = { ...this.filterOptions, [this.selectedKey]: value };
    }

    if (
      this.selectedKey === 'VIN Number' ||
      this.selectedKey === 'Plate Number'
    ) {
      debounseTime = 2000;
    }

    timerId = setTimeout(() => {
      this.isFilterMode = true;
    }, debounseTime);
  }

  resetFilter() {
    this.noFilterMode = true;
    this.isFilterMode = false;
    this.filterOptions = {};

    document.getElementById('make')['value'] = '';
    document.getElementById('model')['value'] = '';
    document.getElementById('trim-type')['value'] = '';
    document.getElementById('model-year')['value'] = '';
    document.getElementById('exterior-color')['value'] = '';
    document.getElementById('active-inactive-status')['value'] = '';
    document.getElementById('vin-number')['value'] = '';
    document.getElementById('registration-number')['value'] = '';
  }
}
